module.exports = __webpack_public_path__ + "img/TM.b5f65296.svg";